<ng-container>
    <ng-content *ngIf="beto">
        <div class="row header-row">
            <div class="col">
                <h5>{{beto.Titulo}}</h5>
            </div>
        </div>
        <div class="row" id="description">
            <div class="col">
                <div class="row">
                    <div class="col">
                        <div class="flex">
                            <strong>{{"Data de inclusão" | translate }}:</strong>
                            <p>{{beto.Alteracoes.CriadoEm | date :'dd/MM/yyyy'}}</p>
                        </div>
                    </div>
                    <div class="col">
                        <div class="flex">
                            <strong>{{"Tipo de produto" | translate}}:</strong>
                            <p>{{beto.DescricaoTipoProduto}}</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="flex">
                            <strong>{{"Data de visita ao parque" | translate}}:</strong>
                            <p>{{beto.DataEscolhida | date :'dd/MM/yyyy'}}</p>
                        </div>
                    </div>
                    <div class="col">
                        <div class="flex">
                            <strong>{{"Descrição" | translate}}:</strong>
                            <p>{{beto.DescricaoCliente}}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="flex">
                                <div class="col-3 flex" [ngSwitch]="beto.Status">
                                    <h6>{{ "Status: " | translate}}</h6>
                                    <span *ngSwitchCase="0" class="badge rounded-pill bg-secondary">Pendente</span>
                                    <span *ngSwitchCase="1" class="badge rounded-pill bg-secondary">Aguardando</span>
                                    <span *ngSwitchCase="2" class="badge rounded-pill bg-secondary">Reserva
                                        Parcial</span>
                                    <span *ngSwitchCase="3" class="badge rounded-pill bg-success">Reservado</span>
                                    <span *ngSwitchCase="4" class="badge rounded-pill bg-success">Solicitado</span>
                                    <span *ngSwitchCase="5" class="badge rounded-pill bg-success">Emitido</span>
                                    <span *ngSwitchCase="6" class="badge rounded-pill bg-success">Pago</span>
                                    <span *ngSwitchCase="7" class="badge rounded-pill bg-warning text-dark">Problema
                                        Técnico</span>
                                    <span *ngSwitchCase="8"
                                        class="badge rounded-pill bg-warning text-dark">Cancelado</span>
                                    <span *ngSwitchCase="9"
                                        class="badge rounded-pill bg-warning text-dark">Excluído</span>
                                    <span *ngSwitchCase="10"
                                        class="badge rounded-pill bg-warning text-dark">Cancelamento com
                                        Problema</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-1 d-flex mr-auto align-self-center badge rounded-pill bg-secondary"
                            *ngIf="beto.Localizador > 2">
                            <strong>{{"Loc" | translate}}:&nbsp;</strong> {{beto.Localizador}}
                        </div>
                        <div class="col">
                            <div class="flex">
                                <div class="col flex">
                                    <button *ngIf="(beto.Status == 3 || beto.Status == 4) && statusOrcamento == 6"
                                        class="btn btn-success" (click)="imprimirVoucherEmitter.emit(beto)"
                                        [disabled]="!liberaVoucher">
                                        <span *ngIf="!liberaVoucher" class="fas fa-exclamation-circle"></span>
                                        <span *ngIf="liberaVoucher" class="fas fa-check-circle"></span>
                                        {{liberaVoucher ? 'Voucher' : 'Voucher Pendente'}}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col text-end">
                                <div class="flex">
                                    <strong>{{'Subtotal:' | translate}}</strong>
                                    <p>{{ beto.MoedaListagem.Sigla }} {{ beto.ValorVenda | currency:'BRL':'':'2.2-2' }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <a (click)="modalDetalhes.open()" class="text-primary mt-2"
                                style="text-decoration: underline; font-size: 1.25rem; font-family: Roboto, 'Helvetica Neue', sans-serif;">Ver
                                Detalhes</a>
                        </div>
                        <div class="row">
                            <div class="col text-end">
                                <strong>{{"Total" | translate}}: </strong>
                                <strong class="price">{{ beto.MoedaListagem.Sigla }} {{ beto.ValorVenda |
                                    currency:'BRL':'':'2.2-2'}}</strong>
                            </div>
                        </div>
                        <div class="text-end" id="buttons" *ngIf="!cardSimplificado">
                            <button class="btn btn-outline-danger" *ngIf="beto.Status == 0 || beto.Status == 8"
                                (click)="removerBetoCarrero(beto)">{{ "Excluir" | translate }}</button>
                            <button *ngIf="beto.Status == 0" type="button" class="btn btn-success"
                                (click)="validaSePodeReservar()">Reservar</button>
                            <button *ngIf="beto.Status == 3" type="button" class="btn btn-danger"
                                (click)="modalCancela.open()">Cancelar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-content>
    <div class="row" *ngIf="mensagemSucessoBeto?.length > 10">
        <div class="alert alert-success alert-dismissible" style="width: 100%">
            <a class="close" data-bs-dismiss="alert" (click)="mensagemSucessoBeto = ''" aria-label="close">&times;</a>
            <ul>
                <li>{{mensagemSucessoBeto}}</li>
            </ul>
        </div>
    </div>

    <div class="row" *ngIf="mensagemErroBeto?.length > 10">
        <div class="alert alert-danger alert-dismissible" style="width: 100%">
            <a class="close" data-bs-dismiss="alert" (click)="mensagemErroBeto = ''" aria-label="close">&times;</a>
            <ul>
                <li>{{mensagemErroBeto}}</li>
            </ul>
        </div>
    </div>
    <div class="overlay d-flex justify-content-center" *ngIf="carregando">
        <img src="assets/img/loading1.gif" alt="Loading..." />
    </div>
</ng-container>

<!-- Template para o modal de detalhes -->
<ng-template #tplDetalhes>
    <div class="row">
        <div class="col-12">
            <h5>{{ beto.DescricaoCliente }}</h5>
            <p [innerHTML]="beto.EspecificacaoHtml"></p>
        </div>
    </div>
</ng-template>

<!-- Template para o modal de reserva -->
<ng-template #tplReserva>
    <beto-reserva [Ingresso]="beto" (alterou)="atualizarBeto($event)">
    </beto-reserva>
</ng-template>

<!-- Template para o modal de cancelamento -->
<ng-template #tplCancela>
    <beto-cancela [Ingresso]="beto" (alterou)="atualizarBeto($event)">
    </beto-cancela>
</ng-template>

<!-- Modais agora recebem os templates como input -->
<app-modal #modalDetalhes
    [modalConfig]="{ modalTitle: 'Detalhes Ingressos', hideDismissButton: true, closeButtonLabel: 'Fechar' }"
    [template]="tplDetalhes">
</app-modal>

<app-modal #modalReserva
    [modalConfig]="{ modalTitle: 'Reservar Ingresso', hideDismissButton: true, hideCloseButton: true }"
    [template]="tplReserva">
</app-modal>

<app-modal #modalCancela
    [modalConfig]="{ modalTitle: 'Cancelar Ingresso', hideDismissButton: true, hideCloseButton: true }"
    [template]="tplCancela">
</app-modal>